var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioActive2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#252526"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#808285"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8C11.25 8.64279 11.0594 9.27114 10.7023 9.8056C10.3452 10.3401 9.83758 10.7566 9.24372 11.0026C8.64986 11.2486 7.9964 11.313 7.36596 11.1876C6.73552 11.0622 6.15643 10.7526 5.7019 10.2981C5.24738 9.84358 4.93785 9.26448 4.81245 8.63404C4.68705 8.00361 4.75141 7.35014 4.99739 6.75628C5.24338 6.16242 5.65994 5.65484 6.1944 5.29772C6.72886 4.94061 7.35721 4.75 8 4.75C8.86163 4.75108 9.68765 5.09383 10.2969 5.70309C10.9062 6.31235 11.2489 7.13838 11.25 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioActive2);
export default __webpack_public_path__ + "static/media/radio-active-2.9a0afb293eccdc95fc544c1e5d1ba47c.svg";
export { ForwardRef as ReactComponent };